(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
    function waitForElement(selector, callback) {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
            return;
        }
        const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
                callback(el);
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    waitForElement('.variation_tbl', (el) => {
        const variationDivs = document.querySelectorAll('.variation_tbl');
        var selectedVarIdonload = document.querySelector('input[type="hidden"][name="id"]').value;
        variationDivs.forEach(div => {
            if (div.getAttribute('variation_id') === selectedVarIdonload) {
                div.style.display = 'flex';
            } else {
                div.style.display = 'none';
            }
        });
        const productForm = document.querySelector('form[action="/cart/add"]');
        productForm.addEventListener('change', function (e) {
            var selectedVarId = document.querySelector('input[type="hidden"][name="id"]').value;
            variationDivs.forEach(div => {
                if (div.getAttribute('variation_id') === selectedVarId) {
                    div.style.display = 'flex';
                } else {
                    div.style.display = 'none';
                }
            });
        }); 
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specification-table"] && !Shopify.designMode) return;
  try {
    
    function waitForElement(selector, callback) {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
            return;
        }
        const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
                callback(el);
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    waitForElement('.variation_tbl', (el) => {
        const variationDivs = document.querySelectorAll('.variation_tbl');
        var selectedVarIdonload = document.querySelector('input[type="hidden"][name="id"]').value;
        variationDivs.forEach(div => {
            if (div.getAttribute('variation_id') === selectedVarIdonload) {
                div.style.display = 'flex';
            } else {
                div.style.display = 'none';
            }
        });
        const productForm = document.querySelector('form[action="/cart/add"]');
        productForm.addEventListener('change', function (e) {
            var selectedVarId = document.querySelector('input[type="hidden"][name="id"]').value;
            variationDivs.forEach(div => {
                if (div.getAttribute('variation_id') === selectedVarId) {
                    div.style.display = 'flex';
                } else {
                    div.style.display = 'none';
                }
            });
        }); 
        /* document.querySelectorAll('variant-selects fieldset').forEach(fieldsetEle =>{
            fieldsetEle.querySelectorAll('input[type="radio"]').forEach(inputRadio =>{
                inputRadio.addEventListener('change',function(){
                    console.log("111111");
                    var selectedVarId = document.querySelector('input[type="hidden"][name="id"]').value;
                    variationDivs.forEach(div => {
                         console.log(div.getAttribute('variation_id')+"<-------->"+selectedVarId);
                        if (div.getAttribute('variation_id') === selectedVarId) {
                            div.style.display = 'flex';
                        } else {
                            div.style.display = 'none';
                        }
                    });
                });
            });
        }); */
    });

  } catch(e) { console.error(e); }
})();
})();
